import { type EnvironmentId, type ServerConfig } from "@cmmd-forge/contracts";
import { useSavedEnvironmentRegistryStore } from "./catalog";
import * as savedCloud from "./savedCloudEnvironmentLifecycle";
import { useSavedEnvironmentRuntimeStore } from "./savedEnvironmentRuntimeStore";

function isoNow(): string {
  return new Date().toISOString();
}

export function setRuntimeConnecting(environmentId: EnvironmentId): void {
  useSavedEnvironmentRuntimeStore.getState().patch(environmentId, {
    connectionState: "connecting",
    lastError: null,
    lastErrorAt: null,
  });
}

export function setRuntimeConnected(environmentId: EnvironmentId): void {
  const connectedAt = isoNow();
  useSavedEnvironmentRuntimeStore.getState().patch(environmentId, {
    connectionState: "connected",
    authState: "authenticated",
    connectedAt,
    disconnectedAt: null,
    lastError: null,
    lastErrorAt: null,
  });
  useSavedEnvironmentRegistryStore.getState().markConnected(environmentId, connectedAt);
}

export function setRuntimeServerConfig(
  environmentId: EnvironmentId,
  serverConfig: ServerConfig,
): void {
  useSavedEnvironmentRuntimeStore.getState().patch(environmentId, {
    descriptor: serverConfig.environment,
    serverConfig,
  });
}

export function setRuntimeDisconnected(environmentId: EnvironmentId, reason?: string | null): void {
  useSavedEnvironmentRuntimeStore.getState().patch(environmentId, {
    connectionState: "disconnected",
    disconnectedAt: isoNow(),
    ...(reason && reason.trim().length > 0
      ? {
          lastError: reason,
          lastErrorAt: isoNow(),
        }
      : {}),
  });
}

export function setRuntimeError(environmentId: EnvironmentId, error: unknown): void {
  useSavedEnvironmentRuntimeStore.getState().patch(environmentId, {
    connectionState: "error",
    ...savedCloud.getRuntimeErrorFields(error),
  });
}
